import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { createPortal } from 'react-dom';

const AnimatedBottomSheet = ({
    isOpen,
    onClose,
    children,
    fullScreen = false,
    maxHeightClassName = 'max-h-[88vh] [max-height:88dvh]',
    className = '',
    zIndex = 1200,
    ariaLabel = 'Dialog',
    closeOnBackdrop = true,
}) => {
    if (typeof document === 'undefined') return null;

    const panelHeightClassName = fullScreen
        ? 'h-screen max-h-screen [height:100dvh] [max-height:100dvh]'
        : maxHeightClassName;

    return createPortal(
        <AnimatePresence>
            {isOpen ? (
                <motion.div
                    className="fixed inset-0"
                    style={{ zIndex }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2, ease: 'easeOut' }}
                >
                    <button
                        type="button"
                        aria-label={`Close ${ariaLabel}`}
                        onClick={closeOnBackdrop ? onClose : undefined}
                        className="absolute inset-0 h-full w-full cursor-default bg-slate-950/35"
                    />
                    <motion.section
                        role="dialog"
                        aria-modal="true"
                        aria-label={ariaLabel}
                        className={`absolute bottom-0 flex w-full min-h-0 flex-col rounded-t-[28px] bg-white shadow-2xl ${panelHeightClassName} ${className}`}
                        initial={{ y: '100%' }}
                        animate={{ y: 0 }}
                        exit={{ y: '100%' }}
                        transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <div className="flex justify-center pb-1 pt-3">
                            <span className="h-1 w-9 rounded-full bg-slate-300" />
                        </div>
                        {children}
                    </motion.section>
                </motion.div>
            ) : null}
        </AnimatePresence>,
        document.body
    );
};

export default AnimatedBottomSheet;
